import { useRecoilValue } from 'recoil';
import { userAtom } from '../state';
import { Permission, roleToPermissions } from '../userPermissionConfig';

export const useFeaturePermission = () => {
  const user = useRecoilValue(userAtom);

  const hasPermission = (product: Permission): boolean => {
    if (!user || !user.role) {
      return false;
    }
    return roleToPermissions?.[user.role]?.[product];
  };

  const runForPermission = (
    product: Permission,
    callback: CallableFunction,
  ) => {
    if (!user || !user.role) {
      return;
    }
    if (!roleToPermissions?.[user.role]?.[product]) {
      return;
    }
    callback();
  };

  return { hasPermission, runForPermission };
};
